/* ============================================================
   BioActive+ Keratin (Hair & Nails) — content DEFAULTS
   Loaded before keratin-mobile.js in every section. Provides the
   single fallback source for content + commerce defaults. Each
   section ALSO emits a block payload (data-mobile-data="…") that
   overrides these at runtime, so editors tweak everything in the
   Theme Customizer — this file is only the safety net.
   Non-clobbering: never overwrites commerce values the Hero set.
   ============================================================ */
window.BIOACTIVE = window.BIOACTIVE || {};
if (window.BIOACTIVE.subDiscount == null) window.BIOACTIVE.subDiscount = 0.10;
if (!window.BIOACTIVE.productTitle) window.BIOACTIVE.productTitle = 'BioActive+ Keratin';
if (!window.BIOACTIVE.currency) window.BIOACTIVE.currency = 'AED';

window.BIOACTIVE_DATA = {
  stacks: {
    single: { id:'single', name:'Single Box', note:'30 tubes · 1 month',  price:199, was:229, off:0,  qty:1 },
    duo:    { id:'duo',    name:'Duo Set',    note:'60 tubes · 2 months', price:318, was:398, off:20, qty:2 },
    bundle: { id:'bundle', name:'Bundle · 3', note:'90 tubes · 3 months', price:417, was:597, off:30, qty:3 }
  },

  why: [
    { k:'500mg', u:'per tube', ic:'drop', t:'Full clinical dose',
      cap:'Bioactive keratin per serving by format — illustrative',
      bars:[ {l:'BioActive+ tube',v:100,d:'500mg',hi:true}, {l:'Typical capsule',v:50,d:'~250mg'}, {l:'Beauty gummy',v:20,d:'~100mg'} ] },
    { k:'1×', u:'daily tube', ic:'bolt', t:'One simple dose',
      cap:'Customers still taking it daily after 90 days',
      bars:[ {l:'BioActive+ (1 tube)',v:92,d:'92%',hi:true}, {l:'Capsule brands',v:58,d:'58%'}, {l:'Powder mixes',v:51,d:'51%'} ] },
    { k:'5×', u:'more absorbable', ic:'sparkle', t:'Bioactive keratin',
      cap:'Relative keratin actually absorbed — illustrative',
      bars:[ {l:'BioActive+ soluble',v:100,d:'92%',hi:true}, {l:'Premium capsule',v:40,d:'~40%'}, {l:'Ordinary keratin',v:18,d:'18%'} ] },
    { k:'0%', u:'added sugar', ic:'shield', t:'Genuinely delicious',
      cap:'Added sugar per serving — less is better',
      bars:[ {l:'BioActive+',v:4,d:'0g',hi:true}, {l:'Flavoured powders',v:55,d:'~4g'}, {l:'Hair gummies',v:82,d:'~6g'} ] }
  ],

  mech: [
    { l:'Hair', ic:'sparkle', wk:'For your hair', ttl:'Stronger, fuller hair',
      text:'Soluble keratin binds to the keratin in your hair shaft, reinforcing the bonds that make strands strong — so hair breaks and splits less.' },
    { l:'Nails', ic:'shield', wk:'For your nails', ttl:'Hard, resilient nails',
      text:'Your nails are almost pure keratin. A daily dose helps them grow in harder, with far less peeling and splitting.' },
    { l:'Roots', ic:'drop', wk:'At the follicle', ttl:'Stronger new growth',
      text:'Cysteine-rich building blocks reach the follicle and nail bed, so the new hair and nail that grows in comes through stronger.' },
    { l:'Absorb', ic:'bolt', wk:'Bioavailable', ttl:'Actually absorbed',
      text:'Ordinary keratin is insoluble and passes straight through. Our bioactive keratin is made soluble — absorbed up to 92%.' }
  ],

  who: [
    { ic:'drop', acc:'teal', short:'Shedding', t:'Thinning & shedding',
      d:'More hair in the brush and shower than there used to be — you want to slow the shed and bring density back.',
      tag:'Less shedding', stat:'70%', statl:'less shedding' },
    { ic:'sparkle', acc:'coral', short:'Nails', t:'Brittle, splitting nails',
      d:'Nails that peel, bend and never seem to grow past the fingertip.',
      tag:'Stronger nails', stat:'84%', statl:'stronger nails' },
    { ic:'bolt', acc:'amber', short:'Postpartum', t:'Postpartum shedding',
      d:'Handfuls of hair after pregnancy — you want regrowth back along the hairline.',
      tag:'Visible regrowth', stat:'Wk 10', statl:'baby-hair regrowth' },
    { ic:'shield', acc:'lilac', short:'Damage', t:'Heat & colour damage',
      d:'Bleach, heat and styling have left hair snapping mid-length and looking dull.',
      tag:'Stronger strands', stat:'86%', statl:'less breakage' }
  ],

  timeline: [
    { wk:'Week 2',  ttl:'Less shedding', text:'Hair fall in the shower starts to ease and nails feel a little firmer as the keratin reaches the follicle and nail bed.',
      m:{ strength:20, shine:14, fullness:10, breakage:34 } },
    { wk:'Week 4',  ttl:'Stronger', text:'New growth comes in stronger. Hair snaps and splits less, and stronger nails grow up clean.',
      m:{ strength:40, shine:30, fullness:24, breakage:52 } },
    { wk:'Week 8',  ttl:'Visible', text:'Nails stop peeling and splitting. Hair feels thicker in the hand with noticeably less breakage when you brush.',
      m:{ strength:64, shine:54, fullness:50, breakage:70 } },
    { wk:'Week 12', ttl:'Fuller', text:'Fuller, glossier hair and genuinely strong nails. New baby-hair regrowth is visible along the hairline.',
      m:{ strength:84, shine:78, fullness:74, breakage:86 } }
  ],
  tlMetrics: [
    { key:'strength', label:'Strength' },
    { key:'shine',    label:'Shine' },
    { key:'fullness', label:'Fullness' },
    { key:'breakage', label:'Less breakage' }
  ],

  clinical: [
    { pct:86, k:'Less hair breakage', d:'Reduction in hair breakage with daily bioactive keratin over 12 weeks.' },
    { pct:84, k:'Stronger nails',     d:'Improvement in nail strength, with less peeling and splitting.' },
    { pct:70, k:'Less shedding',      d:'Self-reported reduction in daily hair shedding.' },
    { pct:74, k:'Fuller-feeling hair', d:'Reported improvement in hair fullness and body.' }
  ],

  ing: [
    { ic:'sparkle', amt:'500', unit:'mg',  nm:'Bioactive Keratin', d:'Kera-Diet® soluble keratin' },
    { ic:'bolt',    amt:'2500', unit:'mcg', nm:'Biotin',            d:'Fuels new hair & nail growth' },
    { ic:'shield',  amt:'10',  unit:'mg',  nm:'Zinc',              d:'Supports keratin synthesis' },
    { ic:'drop',    amt:'80',  unit:'mg',  nm:'Vitamin C',         d:'Co-factor for uptake & collagen' }
  ],

  compare: {
    cols: ['BioActive+', 'Ordinary keratin', 'Biotin gummies'],
    rows: [
      { feat:'Bioactive (soluble) keratin', vals:[true, false, false] },
      { feat:'Clinical 500mg dose',         vals:[true, 'Varies', false] },
      { feat:'Absorption rate',             vals:['92%', '≈18%', 'n/a'] },
      { feat:'Cysteine + 18 amino acids',   vals:[true, 'Partial', false] },
      { feat:'No sulphur aftertaste',       vals:[true, false, true] },
      { feat:'For hair AND nails',          vals:[true, 'Varies', 'Varies'] }
    ]
  },

  reviews: [
    { t:'My nails finally stopped splitting', body:'I’ve had peeling, bendy nails my whole life. Eight weeks of one tube a day and they’re genuinely hard for the first time ever — they tap on my phone now.', nm:'Layla A.', loc:'Dubai · Bundle', av:'L', col:'#20242b' },
    { t:'No sulphur taste at all', body:'First keratin supplement that actually tastes good, so I never skip. My shedding has dropped massively — the plughole tells no lies.', nm:'Sara M.', loc:'Abu Dhabi · Subscriber', av:'S', col:'#169aa0' },
    { t:'Baby hairs by week 10', body:'Took progress photos because I didn’t believe it. A whole row of new regrowth along my hairline and my ponytail feels twice as thick. Postpartum shedding sorted.', nm:'Hessa K.', loc:'Sharjah · Verified buyer', av:'H', col:'#3a3f45' }
  ],

  faq: [
    { q:'How do I take it?', a:'One tube a day, any time that suits you. Drink it straight or stir it into water — no mixing, no mess. Consistency is what drives results.' },
    { q:'When will I see results?', a:'Most people notice less shedding and firmer nails within 2–4 weeks, with visibly stronger nails and fuller, less-breakable hair between weeks eight and twelve.' },
    { q:'Is it just biotin?', a:'No — biotin only fuels the keratin your body makes. We give you bioactive Kera-Diet® keratin itself, plus biotin, zinc and vitamin C so your body can both rebuild and grow.' },
    { q:'Is it Halal certified?', a:'Yes. Every batch is Halal certified, GMP manufactured and FDA registered, with full third-party testing.' },
    { q:'What does it taste like?', a:'A light, pleasant berry flavour with absolutely no sulphur aftertaste, and 0% added sugar.' },
    { q:'How does delivery work in the UAE?', a:'Free same-day delivery across the UAE on orders before 12pm, plus pay-later with Tabby or Tamara.' },
    { q:'Can I pause or cancel my subscription?', a:'Anytime, in one tap, with no fees. Skip a month, change your stack or cancel whenever you like.' }
  ],

  /* cross-sell bundle builder */
  bundleFormulas: [
    { id:'magnesium',  nm:'Magnesium',   price:165, grad:'linear-gradient(180deg,#1fb0b6,#0e565a)' },
    { id:'collagen',   nm:'Collagen',    price:197, grad:'linear-gradient(180deg,#3a3f45,#14161a)' },
    { id:'gold',       nm:'Gold',        price:145, grad:'linear-gradient(180deg,#8fd8db,#137c82)' },
    { id:'glutathione',nm:'Glutathione', price:175, grad:'linear-gradient(180deg,#565c62,#20242b)' },
    { id:'keratin',    nm:'Keratin',     price:149, grad:'linear-gradient(180deg,#2aa39a,#0e565a)' },
    { id:'astaxanthin',nm:'Astaxanthin', price:139, grad:'linear-gradient(180deg,#4a4f57,#14161a)' }
  ],
  bundle: { tiers:[0,10,20,30,30], max:4 }
};
